<app-breadcrumb
  [title]="page_name"
  [breadcrumb]="page_name"
  [currentUrl]="currentUrl"
></app-breadcrumb>
<!-- personal deatail section start -->
<section class="contact-page register-page">
  <div class="container">
    <div class="row">
      <div class="col-sm-3">
        <div class="account-sidebar" (click)="ToggleDashboard()">
          <a hre="javascript:void(0)" class="popup-btn">
            {{ "my account" | translate }}
          </a>
        </div>
        <div class="dashboard-left" [class.open]="openDashboard">
          <div class="collection-mobile-back" (click)="ToggleDashboard()">
            <span class="filter-back">
              <i class="fa fa-angle-left" aria-hidden="true"></i>
              {{ "Back" | translate }}
            </span>
          </div>
          <div class="block-content">
            <ul>
              <ul>
                <li>
                  <a data-lng="es" [routerLink]="'/pages/dashboard'">
                    {{ "address" | translate }}
                  </a>
                </li>
                <li>
                  <a data-lng="es" [routerLink]="'/pages/my-orders'">
                    {{ "orders" | translate }}
                  </a>
                </li>
                <li class="active">
                  <a data-lng="es" [routerLink]="'/pages/my-coupones'">
                    {{ "coupones" | translate }}
                  </a>
                </li>
                <li>
                  <a data-lng="es" [routerLink]="'/pages/browse-log'">
                    {{ "browse log" | translate }}
                  </a>
                </li>

                <li>
                  <a data-lng="es" [routerLink]="'/pages/profile'">
                    {{ "my profile" | translate }}
                  </a>
                </li>
                <li>
                  <a
                    data-lng="es"
                    href="javascript:void(0)"
                    (click)="userLogOut()"
                  >
                    {{ "logout" | translate }}
                  </a>
                </li>
              </ul>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-sm-9">
        <div class="upper-title-layout">
          <div
            class="title-up-block active-title-block"
            [ngClass]="
              usedCouponesActive
                ? 'not-active-title-block'
                : 'active-title-block'
            "
            (click)="usedCouponesActive = false"
          >
            <h3>الفعالة</h3>
          </div>
          <div
            class="title-up-block"
            [ngClass]="
              usedCouponesActive
                ? 'active-title-block'
                : 'not-active-title-block'
            "
            (click)="usedCouponesActive = true"
          >
            <h3>المستخدمة</h3>
          </div>
        </div>
        <div class="content-layout-used-coupones" *ngIf="usedCouponesActive">
          <div class="loader-layout">
            <img
              class=""
              src="assets/images/loader.gif"
              *ngIf="!finished && usedCouponesList.length == 0"
            />
          </div>

          <div class="coupone-block" *ngFor="let coupone of usedCouponesList">
            <div class="title">
              {{ coupone.title }}
            </div>
            <div class="sub-title" [innerHTML]="coupone.description">
              <!-- {{coupone.description}} -->
            </div>
            <div class="bottom-card-layout">
              <div class="code-box">
                {{ coupone.code }}
              </div>
              <div class="copy-code-block" (click)="copyMessage(coupone.code)">
                {{ "copy code" | translate }}
              </div>
            </div>
          </div>

          <div
            class="no-data-found"
            *ngIf="finished && usedCouponesList.length == 0"
          >
            {{ "no coupones found" | translate }}
          </div>
        </div>
        <div class="content-layout-used-coupones" *ngIf="!usedCouponesActive">
          <div class="loader-layout">
            <img
              class=""
              src="assets/images/loader.gif"
              *ngIf="!finished && activeCouponesList.length == 0"
            />
          </div>

          <div class="coupone-block" *ngFor="let coupone of activeCouponesList">
            <div class="title">
              {{ coupone.title }}
            </div>
            <div class="sub-title" [innerHTML]="coupone.description">
              <!-- {{coupone.description}} -->
            </div>
            <div class="bottom-card-layout">
              <div class="code-box">
                {{ coupone.code }}
              </div>
              <div class="copy-code-block" (click)="copyMessage(coupone.code)">
                {{ "copy code" | translate }}
              </div>
            </div>
          </div>
          <div
            class="no-data-found"
            *ngIf="finished && activeCouponesList.length == 0"
          >
            {{ "no coupones found" | translate }}
          </div>
        </div>

        <!-- <h3>{{'PERSONAL DETAIL' | translate }}</h3>
                 -->
      </div>
    </div>
  </div>
</section>

<!-- login -->
<section #login class="full-sidebar" *ngIf="loginclicked">
  <div class="shadow login-sidebar">
    <i class="ti-close login-icon" (click)="close()"></i>
    <app-fast-login
      (step5Reached)="onStep5Reached()"
      (stepSuccessReached)="onstepSuccessReached()"
    ></app-fast-login>
  </div>
</section>
